<template>
   <div class="max-w-full mx-auto">
      <form class="relative">
         <InputGroup>
            <InputText
               size="small"
               v-model="model"
               type="search"
               :placeholder="placeholderText ?? $t('misc.search')"
            />
            <div class="flex items-center absolute right-20 bottom-1.5 z-10">
               <button
                  size="small"
                  severity="contrast"
                  variant="text"
                  @click.prevent="onClear"
                  v-if="showClear"
               >
                  <i
                     class="pi pi-times text-black"
                  />
               </button>
            </div>
            <Button
               size="small"
               @click.prevent="onSearchClicked"
               type="submit"
               :label="$t('misc.search')"
            />
         </InputGroup>
      </form>
      <Popover
         ref="op"
         :distance="10"
         :placement="'top'"
         :disabled="canSearch"
      >
         <p class="text-sm font-normal">
            {{ $t('misc.search_term_characters') }}
         </p>
      </Popover>
   </div>
</template>
<script setup>
   import { Button, Popover, InputText, InputGroup } from 'primevue';
   import { computed, ref } from 'vue';
   import { isEmpty } from 'lodash';
   const op = ref();
   defineProps({
      placeholderText :String,
   });

   const model = defineModel({
      type: String,
      required: true,
   });

   const canSearch = ref(false);

   const emit = defineEmits(['clearSearch', 'onSearch']);

   const onClear = () => emit('clearSearch');

   const showClear = computed(() => !isEmpty(model.value));

   const onSearchClicked = (event) => {
      if (isEmpty(model.value) || model.value.length < 3) {
         op.value.toggle(event);
         return;
      }
      canSearch.value = true;
      emit('onSearch', model.value);
   };

</script>

